<fieldset ngModelGroup="territoire-generalites">
    <mat-card>
        <mat-card-title>
            <span [translate]="'admin.bibliotheque.geographie.territoire.title'" [translateParams]="{libelle: ''}"></span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelle"
                                  name="libelle"
                                  [(ngModel)]="territoire.libelle"
                                  customType="input"
                                  libelle="admin.bibliotheque.geographie.territoire.libelle"
                                  [required]="true">
                    </custom-input>
                    <custom-input
                                  ngDefaultControl
                                  id="actif"
                                  name="actif"
                                  [ngModel]="territoire.actif"
                                  [(customModel)]="territoire.actif"
                                  customType="checkbox"
                                  libelle="admin.bibliotheque.geographie.territoire.actif">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="code"
                                  name="code"
                                  [(ngModel)]="territoire.code"
                                  customType="input"
                                  libelle="admin.bibliotheque.geographie.territoire.code">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="visibilite"
                                  name="visibilite"
                                  [(ngModel)]="territoire.listeVisibilites"
                                  customType="multiselect"
                                  optionValue="id"
                                  optionDisplay="libelle"
                                  libelle="admin.bibliotheque.geographie.territoire.visibilite"
                                  [selectOptions]="listeVisibilites"
                                  [postTooltip]="'admin.bibliotheque.geographie.territoire.tooltipVisibilite' | translate"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="commentaire"
                                  name="commentaire"
                                  [(ngModel)]="territoire.commentaire"
                                  customType="textarea"
                                  rCol="10"
                                  libelle="admin.bibliotheque.geographie.territoire.commentaire"
                    ></custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</fieldset>
